import React from 'react';
import { createTranslationsProvider, } from '@wix/package-picker-common';
const PP_COMPONENTS_TRANSLATIONS_NAMESPACE = 'packagePickerComponents';
const { TranslationsProvider, useTranslations } = createTranslationsProvider({
    providerName: 'ComponentsTranslationsProvider',
    namespace: PP_COMPONENTS_TRANSLATIONS_NAMESPACE,
});
export const ComponentsTranslationsProvider = (props) => {
    const [resources, setResources] = React.useState(null);
    const language = props.i18n.options.lng ?? 'en';
    React.useEffect(() => {
        import(
        /* webpackChunkName: "package-picker-components-translations" */ `../assets/locale/messages_${language}.json`)
            .then((res) => {
            setResources(res.default);
        })
            .catch((e) => {
            console.log(e);
        });
    }, [language]);
    return React.createElement(TranslationsProvider, { resources: resources, ...props });
};
export { useTranslations as useComponentsTranslations };
//# sourceMappingURL=ComponentsTranslationsProvider.js.map